import AdminDownloadsPage from './AdminDownloadsPage';
export default AdminDownloadsPage;